import config from "@/config";
import Axios from "@/utils/Axios";
// import { captureException } from "@sentry/react";

export const getShortUrl = (url: string) => {
  return Axios.post("/short/convert", { url }, {}, config.creatorUrl);
};

// 主要用来错误上报
export const getQrCodeImage = async (path: string) => {
  return fetch(`${config.adminUrl}weixin${path}`).then((res) => {
    if (!res.ok) {
      // captureException(
      //   new Error(`[api-request-error]: ${res.status} ${res.url}: ${res.statusText}`),
      //   {
      //     level: "fatal",
      //     contexts: {
      //       message: {
      //         url: config.adminUrl + path,
      //         method: res.headers.get("method"),
      //         status: res.status,
      //         statusText: res.statusText,
      //       },
      //     },
      //   },
      // );
      return null;
    }

    return res.blob();
  });
};
